import React, {useEffect, useState} from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const InputRichText = props => {
    const { attribute, returnType, classname, value, placeholder, handleChange } = props;
    const [ firstPassed, setFirstPassed ] = useState(true);
    const [ entry, setEntry ] = useState(value);

    const changeEvent = () => {
        if (handleChange === undefined || handleChange === null) return;

        handleChange(attribute, returnType, entry);
    }

    useEffect(() => {
		if (!firstPassed)
        	changeEvent();

		setFirstPassed(false);
    }, [entry]);

    return (
		<ReactQuill id={"richInput_" + attribute} className={"richInput" + (classname !== undefined ? " " + classname : "")} theme={"snow"} placeholder={placeholder} value={entry} onChange={setEntry} />
    );
}

export default InputRichText;
